<template>
  <div class="viewcontent" v-if="translations.buttons && translations.errors">
    <button
      class="btn btn-primary m-1"
      @click="add()"
      :disabled="usertype !== 2"
    >
      {{ translations.buttons.btn_add_equipment }}
    </button>
    <table class="table table-striped" id="customers">
      <thead>
        <tr>
          <th class="col">{{ translations.table.tb_picture }}</th>
          <th class="col">{{ translations.table.tb_title }}</th>
          <th class="col">{{ translations.table.tb_action }}</th>
        </tr>
      </thead>

      <tbody class="list" v-if="equipments.length > 0">
        <tr v-for="(item, index) in equipments" :key="index">
          <td class="col  align-middle" @click="edit(item.id)">
            <div
              class="picture"
              :style="`background-image: url(${files + item.picture})`"
            ></div>
          </td>

          <th class="col  align-middle" @click="edit(item.id)">
            {{ defineTitle(item.title) }}
          </th>
          <td class="col  align-middle">
            <button
              class="btn btn-danger m-1"
              @click="delet(item.id)"
              :disabled="usertype !== 2"
            >
              <img :src="require('@/assets/icon/false.svg')" class="svg" />
            </button>
          </td>
        </tr>
      </tbody>
      <tbody class="bg-empty" v-else>
        <tr>
          <td colspan="4" class="col-12">
            <Alert type="warning" :message="translations.errors.equipment_table"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'

  export default {
    name: 'Equipments',
    components: {
      Alert,
    },
    computed: {
      ...mapState([
        'equipments',
        'languageSelected',
        'files',
        'usertype',
        'translations',
      ]),
    },
    methods: {
      ...mapActions([
        'getEquipments',
        'changeToolSelected',
        'saveEquipmentID',
        'deleteEquipment',
      ]),
      defineTitle(title) {
        let text = ''

        if (title) {
          let result = title.find((x) => x.key === this.languageSelected)
          text = result && result.text ? result.text : title[0].text
        }

        return text
      },
      add() {
        this.changeToolSelected(18)
      },
      async edit(id) {
        if (this.usertype == 2) {
          await this.saveEquipmentID(id)
          this.changeToolSelected(19)
        }
      },
      delet(id) {
        if (this.usertype == 2) {
          this.deleteEquipment(id)
        }
      },
    },
    created() {
      this.getEquipments()
    },
  }
</script>

<style scoped>
  .svg {
    filter: invert(100%) sepia(96%) saturate(16%) hue-rotate(278deg)
      brightness(105%) contrast(104%);
  }
  .list tr:hover {
    background-color: #cecece;
    cursor: pointer;
  }
  .picture {
    width: 50px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    height: 50px;
    margin: 0 auto;
    border-radius: 5px;
  }
</style>
